module.exports = __webpack_public_path__ + "static/media/icon_mail.b7e428d7.svg";